import { combineReducers } from "redux";
import { catalogReducer } from "./catalogReducer";
import { alertReducer } from "./alertReducer";
import { monitoringReducer } from "./monitoringReducer";

//Componente que agrupa todos los reductores
export default combineReducers({
  catalogState: catalogReducer,
  alertState: alertReducer,
  monitoringState: monitoringReducer,
});
